// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"77a6c457","331":"7c3397db","582":"a7e38d45"}[chunkId] + ".css";
};